<div class="tw-container tw-mx-auto tw-p-4">
	<div class="tw-mb-6 tw-flex tw-justify-between tw-items-center">
		<h1 class="tw-text-2xl tw-font-bold">Manage Documents</h1>
		<div class="tw-flex tw-space-x-2"  *ngIf="!loading && groupedFiles.length !== 0">
			<button ngbTooltip="Reload Data" (click)="loadDocuments(null)" class="active:tw-border-spacing-0 print:tw-hidden focus:tw-outline-0 h tw-border-0 tw-text-[#243670] tw-border-[#243670] tw-font-bold tw-px-2 tw-rounded">
				<i [class.fa-refresh]="!loading" [class.fa-spinner]="loading" [class.fa-spin]="loading" class="fa fa-spinner"></i>
			</button>
			<button class="tw-px-4 tw-py-1 tw-bg-green-500 tw-text-white tw-rounded hover:tw-bg-green-600"
			(click)="openAddFileModal()">
			<i class="fa fa-plus tw-mr-1"></i>Upload Files <span class="tw-inline-flex tw-items-center tw-rounded-md tw-bg-gray-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-gray-600 tw-ring-1 tw-ring-gray-500/10 tw-ring-inset">{{files.length}}</span>
		</button>
		<button type="button" class="tw-px-4 tw-py-1 tw-bg-gray-500 tw-text-white tw-rounded hover:tw-bg-gray-600"
		(click)="openManageCategoriesModal()">
	<i class="fa fa-cog"></i> Categories <span class="tw-inline-flex tw-items-center tw-rounded-md tw-bg-gray-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-gray-600 tw-ring-1 tw-ring-gray-500/10 tw-ring-inset">{{availableCategories.length}}</span>
</button>
	</div>
</div>

<div class="tw-container tw-mx-auto">
	<app-component-loader [loading]="loading"></app-component-loader>


	<div *ngIf="!loading && groupedFiles.length === 0" class="tw-bg-gray-50 tw-rounded-lg tw-p-8 tw-text-center tw-my-8">
		<div class="tw-mb-4">
			<i class="fa fa-folder-open-o tw-text-gray-400 tw-text-6xl"></i>
		</div>
		<h3 class="tw-text-xl tw-font-medium tw-mb-2">No Documents Found</h3>

		<button class="tw-px-4 tw-py-2 tw-bg-green-500 tw-text-white tw-rounded hover:tw-bg-green-600"
				(click)="openAddFileModal()">
			<i class="fa fa-plus tw-mr-2"></i>Upload Your First Document
		</button>
	</div>


	<div class="tw-mb-4 tw-bg-gray-100 tw-p-3 tw-rounded tw-flex tw-justify-between tw-items-center" *ngIf="selectedFiles.length > 0">
		<div>
			<span class="tw-font-medium tw-mr-2">
				<span class="tw-inline-flex tw-items-center tw-rounded-md tw-bg-gray-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-gray-600 tw-ring-1 tw-ring-gray-500/10 tw-ring-inset">{{ selectedFiles.length }}</span>
				 files selected</span>
			<button (click)="clearSelection()" class="tw-text-sm tw-text-blue-600 hover:tw-underline">
				Clear selection
			</button>
		</div>
		<div class="tw-flex tw-space-x-2">
			<button class="tw-px-3 tw-py-1 tw-bg-transparent tw-text-gray-600 tw-border tw-border-gray-500 tw-rounded hover:tw-bg-gray-50"
					(click)="openBulkCategoryModal()">
				<i class="fa" [ngClass]="{'fa-spinner fa-spin': bulkCategoryLoading, 'fa-folder-o tw-mr-1': !bulkCategoryLoading}"></i>
				<span *ngIf="!bulkCategoryLoading">Change Category</span>
				<span *ngIf="bulkCategoryLoading">Updating...</span>
			</button>
			<button class="tw-px-3 tw-py-1 tw-bg-transparent tw-text-red-500 tw-border tw-border-red-500 tw-rounded hover:tw-bg-red-50"
					ngbPopover
					[ngbPopover]="bulkDeleteConfirmationTpl"
					popoverTitle="Confirm Bulk Delete"
					placement="bottom-right"
					container="body"
					[autoClose]="true"
					#bulkDeletePopover="ngbPopover"
					[disabled]="bulkDeleteLoading">
				<i class="fa" [ngClass]="{'fa-spinner fa-spin': bulkDeleteLoading, 'fa-trash tw-mr-1': !bulkDeleteLoading}"></i>
				<span *ngIf="!bulkDeleteLoading">Delete Selected</span>
				<span *ngIf="bulkDeleteLoading">Deleting...</span>
			</button>
		</div>
	</div>


	<ngb-accordion #acc="ngbAccordion" [closeOthers]="false" activeIds="panel-0"
	               *ngIf="groupedFiles.length > 0">
		<ngb-panel *ngFor="let group of groupedFiles; let i = index" [id]="'panel-' + i">

			<ng-template ngbPanelHeader>
				<div class="tw-flex tw-items-center tw-justify-between tw-w-full tw-px-3 tw-py-2">
					<button ngbPanelToggle class="tw-btn tw-btn-link tw-p-0 tw-text-decoration-none tw-text-left tw-text-dark tw-flex tw-items-center">
						<i class="fa fa-chevron-down tw-transition-transform tw-mr-2 accordion-icon"
						   [class.tw-rotate-180]="acc.isExpanded('panel-' + i)"></i>
						{{ getCategoryNameById(group.category) }}
					</button>
					<div class="tw-flex tw-items-center">
						<button class="tw-px-2 tw-py-1 tw-bg-transparent tw-text-gray-600 tw-border tw-border-gray-300 tw-rounded hover:tw-bg-gray-50 tw-flex tw-items-center"
								(click)="$event.stopPropagation(); downloadAllFilesInCategory(group.category)"
								[disabled]="group.files.length === 0">
							<i class="fa fa-download tw-mr-1"></i>
							Download All
							<span class="tw-ml-1 tw-inline-flex tw-items-center tw-rounded-md tw-bg-gray-50 tw-px-1.5 tw-py-0.5 tw-text-xs tw-font-medium tw-text-gray-600 tw-ring-1 tw-ring-gray-500/10 tw-ring-inset">{{ group.files.length }}</span>
						</button>
					</div>
				</div>
			</ng-template>

			<ng-template ngbPanelContent>

				<div class="tw-border-t tw-border-gray-100">
					<table class="tw-w-full tw-border-collapse tw-text-sm" cdkDropList (cdkDropListDropped)="drop($event, group.files)">
						<thead class="tw-bg-gray-50">
							<tr class="tw-border-b tw-border-gray-200">
								<th class="tw-w-8 tw-p-2">
									<input type="checkbox"
									class="tw-ml-2"
										   [checked]="areAllFilesInGroupSelected(group.files)"
										   [indeterminate]="arePartialFilesInGroupSelected(group.files)"
										   (change)="toggleGroupSelection(group.files, $event)">
								</th>
								<th class="tw-w-8 tw-p-2"></th>
								<th *ngFor="let column of sortableColumns.slice(0, -1)" class="tw-p-2 tw-text-left tw-font-medium tw-text-gray-600">
									{{ column.label }}
								</th>
								<th class="tw-w-24 tw-p-2"></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let file of group.files"
									cdkDrag
									[cdkDragData]="file"
									class="tw-border-b tw-border-gray-100 hover:tw-bg-gray-50"
									[ngClass]="{'fade-out': itemToDelete === file.id}">
								<td class="tw-p-2">
									<input type="checkbox"
									class="tw-ml-2"
										   [checked]="isFileSelected(file)"
										   (change)="toggleFileSelection(file, $event)">
								</td>
								<td class="tw-p-2">
									<div cdkDragHandle class="drag-handle tw-border tw-border-gray-200 tw-rounded tw-p-1 tw-cursor-move">
										<i class="fa fa-bars tw-text-gray-400"></i>
									</div>
								</td>
								<td>
									<div *ngIf="!file.isEditing || file.editingField !== 'filename'" class="tw-group tw-relative">
										<span class="tw-cursor-pointer" (click)="startEditing(file, 'filename')">
											{{ file.filename }}
										</span>
										<button class="tw-absolute tw-right-0 tw-top-0 tw-text-gray-400 hover:tw-text-blue-500 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity"
												(click)="startEditing(file, 'filename')"
												ngbTooltip="Edit title">
											<i class="fa fa-pencil"></i>
										</button>
									</div>
									<div *ngIf="file.isEditing && file.editingField === 'filename'" class="tw-flex tw-items-center">
										<input type="text"
											   [(ngModel)]="file.editFilename"
											   class="tw-block tw-w-full tw-border tw-rounded tw-p-1 tw-text-sm"
											   (keydown.enter)="saveField(file, 'filename')"
											   (keydown.escape)="cancelEditing(file, 'filename')"
											   #filenameInput>
										<div class="tw-flex tw-ml-1">
											<button class="tw-text-green-500 hover:tw-text-green-700"
													(click)="saveField(file, 'filename')"
													ngbTooltip="Save">
												<i class="fa fa-check"></i>
											</button>
											<button class="tw-text-red-500 hover:tw-text-red-700 tw-ml-1"
													(click)="cancelEditing(file, 'filename')"
													ngbTooltip="Cancel">
												<i class="fa fa-times"></i>
											</button>
										</div>
									</div>
								</td>
								<td><i class="tw-mr-2" [ngClass]="file.originalFilename | fileType"></i>{{ file.fileType }} </td>
								<td>{{ file.fileSize | fileSize }}</td>
								<td class="tw-truncate tw-max-w-[200px]">
									<div *ngIf="!file.isEditing || file.editingField !== 'description'" class="tw-group tw-relative tw-truncate">
										<span class="tw-cursor-pointer tw-truncate tw-block" (click)="startEditing(file, 'description')"
										[ngClass]="{'tw-text-gray-400': !file.description}"
										ngbTooltip="{{ file.description || 'Click to add description' }}">
											{{ file.description || 'Click to add description' }}
										</span>
										<button class="tw-absolute tw-right-0 tw-top-0 tw-text-gray-400 hover:tw-text-blue-500 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity"
												(click)="startEditing(file, 'description')"
												ngbTooltip="Edit description">
											<i class="fa fa-pencil"></i>
										</button>
									</div>
									<div *ngIf="file.isEditing && file.editingField === 'description'" class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50 tw-z-50">
										<div class="tw-bg-white tw-rounded tw-shadow-xl tw-p-4" style="width: 450px;">
											<div class="tw-flex tw-justify-between tw-items-center tw-mb-3">
												<h3 class="tw-text-lg tw-font-medium">Edit Description</h3>
												<button class="tw-text-gray-400 hover:tw-text-gray-600"
														(click)="cancelEditing(file, 'description')">
													<i class="fa fa-times"></i>
												</button>
											</div>

											<textarea
												[(ngModel)]="file.editDescription"
												class="tw-block tw-w-full tw-border tw-rounded tw-p-2 tw-text-sm tw-mb-3"
												rows="5"
												#descriptionInput></textarea>

											<div class="tw-flex tw-justify-end">
												<button class="tw-bg-gray-300 hover:tw-bg-gray-400 tw-text-gray-800 tw-py-1 tw-px-3 tw-rounded tw-mr-2"
														(click)="cancelEditing(file, 'description')">
													Cancel
												</button>
												<button class="tw-bg-green-500 hover:tw-bg-green-600 tw-text-white tw-py-1 tw-px-3 tw-rounded"
														(click)="saveField(file, 'description')">
													Save
												</button>
											</div>
										</div>
									</div>
								</td>
								<td class="tw-max-w-[120px]">{{ file.created | date:'mediumDate' }}</td>
								<td class="tw-max-w-[120px]">{{ file.updated | date:'mediumDate' }}</td>
								<td>
									<div class="d-flex justify-content-between tw-space-x-2">
										<button class="tw-w-full tw-px-3 tw-py-1 tw-bg-transparent tw-text-red-500 tw-border tw-border-red-500 tw-rounded hover:tw-bg-red-50"
										ngbPopover
										[ngbPopover]="deleteConfirmationTpl"
										popoverTitle="Confirm Delete"
										placement="left"
										container="body"

										#p="ngbPopover"
										(click)="setSelectedFile(file)"> <i class="fa fa-ban" aria-hidden="true"></i></button>
							 <button class="tw-w-full tw-px-3 tw-py-1 tw-bg-transparent tw-text-gray-600 tw-border tw-border-gray-500 tw-rounded hover:tw-bg-gray-50"
									 (click)="openFile(file)" [disabled]="downloadingFileId === file.id">
									 <i class="fa" [ngClass]="{'fa-spinner fa-spin': downloadingFileId === file.id, 'fa-download': downloadingFileId !== file.id}"></i>

								 </button>
									</div>
								</td>
							</tr>
							<!-- No files in category message -->
							<tr *ngIf="group.files.length === 0">
								<td colspan="9" class="text-center py-3">No files in this category</td>
							</tr>
						</tbody>
					</table>
				</div>
			</ng-template>
		</ngb-panel>
	</ngb-accordion>
</div>


<ng-template #deleteConfirmationTpl>
	<div class="tw-text-sm tw-mb-3">Are you sure you want to delete this file? This action cannot be undone.</div>
	<div class="tw-flex tw-justify-end tw-space-x-2">
		<button type="button" class="btn btn-danger btn-sm">
			<i class="fa fa-times tw-mr-1" aria-hidden="true"></i>Cancel
		</button>
		<button type="button" class="btn btn-success btn-sm" (click)="deleteFile(); ">
			<i class="fa fa-check-circle tw-mr-1" aria-hidden="true"></i>Confirm
		</button>
	</div>
</ng-template>

<!-- Add File Modal -->
<ng-template #addFileModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Upload New Document</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<form [formGroup]="uploadForm">
			<div class="tw-mb-4">
				<label for="file" class="tw-block tw-mb-2 tw-font-medium">Select File</label>
				<input type="file" id="file"
					class="tw-block tw-w-full tw-border tw-rounded tw-p-2"
					[ngClass]="{'tw-border-red-500': !fileToUpload && uploadForm.touched, 'tw-border-gray-300': fileToUpload || !uploadForm.touched}"
					(change)="onFileSelected($event)" required>
				<div *ngIf="fileToUpload" class="tw-mt-2 tw-text-sm tw-text-gray-600">
					Selected file: {{ fileToUpload.name }} ({{ fileToUpload.size | fileSize }})
				</div>
				<div *ngIf="!fileToUpload && uploadForm.touched" class="tw-mt-2 tw-text-sm tw-text-red-600">
					Please select a file to upload
				</div>
			</div>

			<div class="tw-mb-4">
				<label for="fileName" class="tw-block tw-mb-2 tw-font-medium">Title</label>
				<input type="text" id="fileName" formControlName="fileName"
					class="tw-block tw-w-full tw-border tw-rounded tw-p-2"
					[ngClass]="{'tw-border-red-500': uploadForm.get('fileName').invalid && (uploadForm.get('fileName').dirty || uploadForm.get('fileName').touched),
							   'tw-border-gray-300': !uploadForm.get('fileName').invalid || (!uploadForm.get('fileName').dirty && !uploadForm.get('fileName').touched)}"
				>
				<div class="tw-mt-1 tw-text-sm"
					[ngClass]="{'tw-text-gray-500': !uploadForm.get('fileName').invalid || (!uploadForm.get('fileName').dirty && !uploadForm.get('fileName').touched),
							   'tw-text-red-600': uploadForm.get('fileName').invalid && (uploadForm.get('fileName').dirty || uploadForm.get('fileName').touched)}">

					<span *ngIf="uploadForm.get('fileName').invalid && (uploadForm.get('fileName').dirty || uploadForm.get('fileName').touched)">
						Title is required
					</span>
				</div>
			</div>

			<div class="tw-mb-4">
				<label for="category" class="tw-block tw-mb-2 tw-font-medium">Category <span class="tw-text-red-500">*</span></label>
				<div class="tw-flex tw-items-center tw-space-x-2">
					<select id="category" formControlName="category"
						class="tw-block tw-w-full tw-border tw-rounded tw-p-2"
						[ngClass]="{'tw-border-red-500': uploadForm.get('category').invalid && (uploadForm.get('category').dirty || uploadForm.get('category').touched),
								  'tw-border-gray-300': !uploadForm.get('category').invalid}">
						<option value="">Select a category</option>
						<option *ngFor="let category of availableCategories" [value]="category.id">
							{{ category.name }}
						</option>
					</select>
					<button type="button" class="tw-px-2 tw-py-2 tw-bg-gray-500 tw-text-white tw-rounded hover:tw-bg-gray-600"
							(click)="openManageCategoriesModal()">
						<i class="fa fa-cog"></i>
					</button>
				</div>
				<div *ngIf="uploadForm.get('category').invalid && (uploadForm.get('category').dirty || uploadForm.get('category').touched)"
					class="tw-mt-1 tw-text-sm tw-text-red-600">
					Category is required
				</div>
			</div>

			<div class="tw-mb-4">
				<label for="description" class="tw-block tw-mb-2 tw-font-medium">Description (Optional)</label>
				<textarea id="description" formControlName="description" rows="3"
					class="tw-block tw-w-full tw-border tw-rounded tw-p-2"
					[ngClass]="{'tw-border-red-500': uploadForm.get('description').invalid && (uploadForm.get('description').dirty || uploadForm.get('description').touched),
							   'tw-border-gray-300': !uploadForm.get('description').invalid || (!uploadForm.get('description').dirty && !uploadForm.get('description').touched)}"></textarea>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="tw-px-4 tw-py-2 tw-bg-gray-300 tw-rounded tw-mr-2"
			(click)="modal.dismiss()">Cancel</button>
		<button type="button"
			class="tw-px-4 tw-py-2 tw-rounded"
			[ngClass]="{
				'tw-bg-green-500 tw-text-white hover:tw-bg-green-600': uploadForm.valid && fileToUpload,
				'tw-bg-gray-300 tw-text-gray-500 tw-cursor-not-allowed': !uploadForm.valid || !fileToUpload || uploading
			}"
			[disabled]="!fileToUpload || !uploadForm.valid || uploading"
			(click)="uploadFile()">
			<i class="fa" [ngClass]="{'fa-spinner fa-spin tw-mr-1': uploading}"></i>
			{{ uploading ? 'Uploading...' : 'Upload' }}
		</button>
	</div>
</ng-template>

<!-- Edit File Modal -->
<ng-template #editFileModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Edit Document</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<form [formGroup]="editForm">
			<div class="tw-mb-4">
				<label for="editFileName" class="tw-block tw-mb-2 tw-font-medium">Title</label>
				<input type="text" id="editFileName" formControlName="fileName"
					class="tw-block tw-w-full tw-border tw-rounded tw-p-2"
					[ngClass]="{'tw-border-red-500': editForm.get('fileName').invalid && (editForm.get('fileName').dirty || editForm.get('fileName').touched),
							   'tw-border-gray-300': !editForm.get('fileName').invalid || (!editForm.get('fileName').dirty && !editForm.get('fileName').touched)}"
					placeholder="Enter a descriptive title for this file">
				<div class="tw-mt-1 tw-text-sm"
					[ngClass]="{'tw-text-gray-500': !editForm.get('fileName').invalid || (!editForm.get('fileName').dirty && !editForm.get('fileName').touched),
							   'tw-text-red-600': editForm.get('fileName').invalid && (editForm.get('fileName').dirty || editForm.get('fileName').touched)}">
					<span *ngIf="editForm.get('fileName').invalid && (editForm.get('fileName').dirty || editForm.get('fileName').touched)">
						Title is required
					</span>
				</div>
			</div>

			<div class="tw-mb-4">
				<label for="editCategory" class="tw-block tw-mb-2 tw-font-medium">Category</label>
				<select id="editCategory" formControlName="category"
					class="tw-block tw-w-full tw-border tw-rounded tw-p-2"
					[ngClass]="{'tw-border-gray-300': true}">
					<option value="">Select a category</option>
					<option *ngFor="let category of availableCategories" [value]="category">
						{{ category }}
					</option>
				</select>
			</div>

			<div class="tw-mb-4">
				<label for="editDescription" class="tw-block tw-mb-2 tw-font-medium">Description</label>
				<textarea id="editDescription" formControlName="description" rows="3"
					class="tw-block tw-w-full tw-border tw-rounded tw-p-2"
					[ngClass]="{'tw-border-red-500': editForm.get('description').invalid && (editForm.get('description').dirty || editForm.get('description').touched),
							   'tw-border-gray-300': !editForm.get('description').invalid || (!editForm.get('description').dirty && !editForm.get('description').touched)}"></textarea>
				<div *ngIf="editForm.get('description').invalid && (editForm.get('description').dirty || editForm.get('description').touched)"
					class="tw-mt-1 tw-text-sm tw-text-red-600">
					Description is required
				</div>
			</div>

			<div class="tw-mb-4">
				<label class="tw-block tw-mb-2 tw-font-medium">Current File</label>
				<div class="tw-p-3 tw-bg-gray-100 tw-rounded tw-flex tw-items-center">
					<i class="{{ selectedFile?.fileType | fileType }} tw-mr-2"></i>
					<span class="tw-truncate">{{ selectedFile?.filename }}</span>
					<span class="tw-ml-2 tw-text-gray-500">({{ selectedFile?.fileSize | fileSize }})</span>
				</div>
			</div>

			<div class="tw-mb-4">
				<label for="editFile" class="tw-block tw-mb-2 tw-font-medium">Replace File (Optional)</label>
				<input type="file" id="editFile"
					class="tw-block tw-w-full tw-border tw-rounded tw-p-2 tw-border-gray-300"
					(change)="onFileSelected($event, 'edit')">
				<div *ngIf="fileToEdit" class="tw-mt-2 tw-text-sm tw-text-gray-600">
					New file selected: {{ fileToEdit.name }} ({{ fileToEdit.size | fileSize }})
				</div>
				<div class="tw-mt-1 tw-text-sm tw-text-gray-500">
					Leave empty to keep the current file.
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="tw-px-4 tw-py-2 tw-bg-gray-300 tw-rounded tw-mr-2"
			(click)="modal.dismiss()">Cancel</button>
		<button type="button"
			class="tw-px-4 tw-py-2 tw-rounded"
			[ngClass]="{
				'tw-bg-blue-500 tw-text-white hover:tw-bg-blue-600': editForm.valid,
				'tw-bg-gray-300 tw-text-gray-500 tw-cursor-not-allowed': !editForm.valid
			}"
			[disabled]="!editForm.valid"
			(click)="updateFile()">Save Changes</button>
	</div>
</ng-template>


<ng-template #bulkDeleteConfirmationTpl>
	<div class="tw-text-sm tw-mb-3">Are you sure you want to delete {{ selectedFiles.length }} files? This action cannot be undone.</div>
	<div class="tw-flex tw-justify-end tw-space-x-2">
		<button type="button" class="btn btn-danger btn-sm" >
			<i class="fa fa-times tw-mr-1" aria-hidden="true"></i>Cancel
		</button>
		<button type="button" class="btn btn-success btn-sm" (click)="bulkDeleteFiles();">
			<i class="fa fa-check-circle tw-mr-1" aria-hidden="true"></i>Confirm
		</button>
	</div>
</ng-template>


<ng-template #bulkCategoryModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Change Category for {{ selectedFiles.length }} Files</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="tw-mb-4">
			<label for="bulkCategory" class="tw-block tw-mb-2 tw-font-medium">New Category</label>
			<select id="bulkCategory" [(ngModel)]="bulkCategory"
				class="tw-block tw-w-full tw-border tw-rounded tw-p-2">
				<option value="">Select a category</option>
				<option *ngFor="let category of availableCategories" [value]="category.id">
					{{ category.name }}
				</option>
			</select>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="tw-px-4 tw-py-2 tw-bg-gray-300 tw-rounded tw-mr-2"
			(click)="modal.dismiss()">Cancel</button>
		<button type="button"
			class="tw-px-4 tw-py-2 tw-bg-green-500 tw-text-white tw-rounded hover:tw-bg-green-600"
			[disabled]="!bulkCategory || bulkCategoryLoading"
			(click)="bulkChangeCategory(); modal.close();">
			<i class="fa" [ngClass]="{'fa-spinner fa-spin tw-mr-1': bulkCategoryLoading}"></i>
			{{ bulkCategoryLoading ? 'Applying...' : 'Apply Changes' }}
		</button>
	</div>
</ng-template>

<!-- Add this new template for managing categories -->
<ng-template #manageCategoriesModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Manage Categories</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="availableCategories.length === 0" class="tw-text-center tw-py-4 tw-text-gray-500">
            No categories available.
        </div>

        <table class="tw-w-full tw-mb-4" *ngIf="availableCategories.length > 0">
            <thead class="tw-bg-gray-50">
                <tr class="tw-border-b tw-border-gray-200">
                    <th class="tw-p-2 tw-text-left tw-font-medium tw-text-gray-600">ID</th>
                    <th class="tw-p-2 tw-text-left tw-font-medium tw-text-gray-600">Name</th>
                    <th class="tw-p-2 tw-w-20"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let category of availableCategories" class="tw-border-b tw-border-gray-100 hover:tw-bg-gray-50">
                    <td class="tw-p-2">{{ category.id }}</td>
                    <td class="tw-p-2">{{ category.name }}</td>
                    <td class="tw-p-2">
                        <button type="button"
                                class="tw-px-2 tw-py-1 tw-bg-red-500 tw-text-white tw-rounded hover:tw-bg-red-600"
                                ngbPopover
                                [ngbPopover]="deleteCategoryConfirmationTpl"
                                popoverTitle="Confirm Delete"
                                placement="left"
                                container="body"
                                [autoClose]="true"
                                (click)="categoryToDelete = category.id">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- New category form -->
        <div class="tw-mt-4 tw-p-3 tw-bg-gray-50 tw-rounded">
            <div class="tw-font-medium tw-mb-2">Add New Category</div>
            <div class="tw-flex tw-space-x-2">
                <input type="text"
                       [(ngModel)]="newCategory"
                       class="tw-block tw-flex-1 tw-border tw-rounded tw-p-2"
                       placeholder="Enter category name">
                <button type="button"
                        class="tw-px-3 tw-py-2 tw-bg-green-500 tw-text-white tw-rounded hover:tw-bg-green-600"
                        [disabled]="!newCategory?.trim()"
                        (click)="addNewCategoryFromManager()">
                    Add
                </button>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="tw-px-4 tw-py-2 tw-bg-gray-300 tw-rounded"
                (click)="modal.close()">Close</button>
    </div>
</ng-template>

<!-- Delete category confirmation template -->
<ng-template #deleteCategoryConfirmationTpl>
    <div class="tw-text-sm tw-mb-3">
        Are you sure you want to delete the {{ getCategoryNameById(categoryToDelete) }} category"?

    </div>
    <div class="tw-flex tw-justify-end tw-space-x-2">
        <button type="button" class="btn btn-sm btn-danger">
            Cancel
        </button>
        <button type="button" class="btn btn-sm btn-success" (click)="deleteCategory()">
            Confirm
        </button>
    </div>
</ng-template>
</div>


